const MEMBER_RACQUET_SPORTS = ['tennis', 'squash', 'pickleball', 'padel']

function normalizeDurationPriceMap(input) {
  const value = typeof input === 'string'
    ? (() => {
      try {
        return JSON.parse(input)
      } catch {
        return null
      }
    })()
    : input

  if (!value || typeof value !== 'object' || Array.isArray(value)) return null

  const normalized = {}
  for (const [rawKey, rawValue] of Object.entries(value)) {
    const minutes = Number.parseInt(String(rawKey || '').trim(), 10)
    const amount = Number(rawValue)
    if (!Number.isInteger(minutes) || minutes <= 0 || !Number.isFinite(amount) || amount < 0) continue
    normalized[String(minutes)] = amount
  }

  return Object.keys(normalized).length ? normalized : null
}

export function normalizeMemberPortalRacquetCourt(row = {}) {
  const defaultDuration = Number(row.default_duration_minutes) || 60
  const bookingInterval = Number.isFinite(Number(row?.booking_interval))
    ? Number(row.booking_interval)
    : defaultDuration
  const bookableStart = row.bookable_start_time || '06:00'
  const bookableEnd = row.bookable_end_time || '22:00'
  const pricingBasis = ['per_court', 'per_person'].includes(String(row?.pricing_basis || '').toLowerCase())
    ? String(row.pricing_basis).toLowerCase()
    : 'per_court'
  const pricingMode = ['hourly', 'duration_fixed', 'duration_per_person'].includes(String(row?.pricing_mode || '').toLowerCase())
    ? String(row.pricing_mode).toLowerCase()
    : 'hourly'
  const durationPriceMap = normalizeDurationPriceMap(row?.duration_price_map)
  const nonMembersAllowed = row?.non_members_allowed === true

  return {
    ...row,
    default_duration_minutes: defaultDuration,
    bookable_start_time: bookableStart,
    bookable_end_time: bookableEnd,
    booking_hours_start: bookableStart,
    booking_hours_end: bookableEnd,
    booking_interval: bookingInterval,
    pricing_basis: pricingBasis,
    pricing_mode: pricingMode,
    duration_price_map: durationPriceMap,
    non_members_allowed: nonMembersAllowed,
  }
}

export function formatSportTypeLabel(rawSport, t) {
  const key = String(rawSport || '').trim().toLowerCase()
  const labels = { tennis: "racquetPlay.tennis", squash: "racquetPlay.squash", pickleball: "racquetPlay.pickleball", padel: "racquetPlay.padel" }
  if (t && labels[key]) return t(labels[key])
  return key.slice(0, 1).toUpperCase() + key.slice(1)
}

export async function fetchMemberRacquetCourts(clubCode, sportType, { memberPortalApiGet } = {}) {
  if (!clubCode) return { data: null, error: 'invalid_club_code' }
  const normalizedSport = String(sportType || '').trim().toLowerCase()
  if (!normalizedSport || !MEMBER_RACQUET_SPORTS.includes(normalizedSport)) {
    return { data: null, error: 'invalid_sport_type' }
  }

  if (typeof memberPortalApiGet !== 'function') {
    return { data: null, error: 'missing_member_portal_api' }
  }

  try {
    const res = await memberPortalApiGet(
      `/api/members-portal/${clubCode}/racquet/courts?sport_type=${normalizedSport}`
    )
    const json = await res.json().catch(() => null)
    if (!res.ok) {
      throw new Error(json?.error || 'racquet_member_courts_fetch_failed')
    }

    const currencyCode =
      json?.data?.currency_code || json?.data?.currency || json?.currency_code || null
    const courtsPayload = Array.isArray(json?.data?.courts)
      ? json.data.courts
      : Array.isArray(json?.data)
        ? json.data
        : []
    const courts = courtsPayload.map(normalizeMemberPortalRacquetCourt)
    return { data: { courts, currencyCode: currencyCode || null }, error: null }
  } catch (err) {
    return { data: null, error: err?.message || 'racquet_member_courts_fetch_failed' }
  }
}

export { MEMBER_RACQUET_SPORTS }
